<script>
import sdgWheels from './../../../js/sdg-wheel/sdg-wheels'
var colors = ['#e5243b', '#dda63a', '#4c9f38', '#c5192d', '#ff3a21', '#26bde2', '#fcc30b', '#a21942', '#fd6925', '#dd1367', '#fd9d24', '#bf8b2e', '#3f7e44', '#0a97d9', '#56c02b', '#00689d', '#19486a']

export default {
  name: 'completed-percent',
  props: {
    percent: {
      type: Number,
      required: true
    },
    color: {
      type: Number,
      required: true
    },
    negative: {
      type: Boolean,
      required: false
    }
  },
  render (h) {
    let options = {
      colors: {
        uncompleted: '#eee',
        completed: colors[this.color - 1]
      },
      negative: this.negative
    }

    let completedPct = new sdgWheels.CompletedPct(options)

    return h('div', {
      domProps: {
        innerHTML: completedPct.getSvgText(this.percent)
      }
    })
  }
}
</script>
